<template>
    <div class="visual-process">
        <h3>Ons schadeproces</h3>
        <div class="grid-container">

            <step1schademelden-component
                :ctx="ctx"
                :schademeldenurl="schademeldenurl"
            ></step1schademelden-component>

            <div class="visual-item">
                <div class="hexagon-thick">
                    <p class="icon icon-archive clean"></p>
                </div>
                <h4>In behandeling</h4>
                <p>Wij nemen uw schademelding in behandeling.</p>
            </div>

            <div class="visual-item">
                <div class="hexagon-thick">
                    <p class="icon icon-user clean"></p>
                </div>
                <h4>Wacht op uw reactie</h4>
                <p>Voor de afhandeling van uw schade hebben wij aanvullende gegevens van u nodig. Hiervan ontvangt u van ons bericht per e-mail en in uw berichtenbox.</p>
            </div>

            <div class="visual-item">
                <div class="hexagon-thick">
                    <p class="icon icon-shield clean"></p>
                </div>
                <h4>Beoordeling</h4>
                <p>Zodra alle gegevens bekend zijn, wordt de schade beoordeeld en z.s.m. afgewikkeld.</p>
            </div>


            <div class="visual-item">
                <div class="hexagon-thick">
                    <p class="icon icon-check clean"></p>
                </div>
                <h4>Afgehandeld</h4>
                <p>Wij hebben uw dossier gesloten of doorgestuurd naar de behandelend verzekeraar.</p>
            </div>

        </div>
    </div>
</template>

<script>

    import step1SchadeMelden from './step1schademelden.vue'

    export default {
        name: 'schadeproces-default',
        components: {
            'step1schademelden-component': step1SchadeMelden
        },
        props: {
            produktnaam: String,
            schademeldenurl: String,
            ctx: String
        },
        data: function () {
            return {
            }
        }
    }

</script>




// WEBPACK FOOTER //
// defaultproces.vue?17135cd9